export const OP_SECTIONS = [
  ["entry", "Inserimento giornaliero", "/stazione"],
  ["history", "Storico e riepilogo", "/stazione/storico"],
  ["assignments", "Assegnazioni", "/stazione/assegnazioni"],
  ["fleet", "Disponibilità furgoni", "/stazione/flotta"],
  ["damages", "Sinistri e franchigie", "/stazione/franchigie"],
  ["rentals", "Noleggi", "/stazione/noleggi"],
  ["telepass", "Telepass", "/stazione/telepass"],
  ["phones", "Telefoni", "/stazione/telefoni"],
  ["requests", "Richieste", "/stazione/richieste"],
  ["documents", "Documenti", "/stazione/documenti"],
  ["tolls", "Mancati pedaggi", "/stazione/pedaggi"],
  ["tyres", "Gomme", "/stazione/gomme"],
  ["forecast", "Forecast furgoni", "/stazione/forecast"],
  ["forms", "Moduli", "/stazione/moduli"],
  ["washes", "Lavaggi", "/stazione/lavaggi"],
  ["adblue", "Magazzino AdBlue", "/stazione/adblue"],
];

export const ADMIN_SECTIONS = [
  ["dashboard", "Dashboard", "/admin"],
  ["control", "Dati per stazione", "/admin/controllo"],
  ["stations", "Stazioni", "/admin/stazioni"],
  ["users", "Utenti (solo operatori e supervisori)", "/admin/utenti"],
  ["assignments", "Assegnazioni", "/admin/assegnazioni"],
  ["fleet", "Disponibilità furgoni", "/admin/flotta"],
  ["damages", "Sinistri e franchigie", "/admin/franchigie"],
  ["rentals", "Noleggi", "/admin/noleggi"],
  ["telepass", "Telepass", "/admin/telepass"],
  ["phones", "Telefoni", "/admin/telefoni"],
  ["requests", "Richieste", "/admin/richieste"],
  ["documents", "Documenti", "/admin/documenti"],
  ["tolls", "Mancati pedaggi", "/admin/pedaggi"],
  ["tyres", "Gomme", "/admin/gomme"],
  ["forecast", "Forecast furgoni", "/admin/forecast"],
  ["forms", "Moduli", "/admin/moduli"],
  ["washes", "Lavaggi", "/admin/lavaggi"],
  ["adblue", "Magazzino AdBlue", "/admin/adblue"],
  ["import", "Importa Excel", "/admin/importa"],
  ["ai", "Assistente AI", "/admin/assistente"],
];

const limited = (user) => (user?.role !== "admin" || user.office) && Array.isArray(user?.sections);

export const canSee = (user, id) => !limited(user) || user.sections.includes(id);

export const homeFor = (user) => {
  const list = user.role === "admin" ? ADMIN_SECTIONS : OP_SECTIONS;
  return list.find(([id]) => canSee(user, id))?.[2] || (user.role === "admin" ? "/admin/nessuna" : "/stazione/nessuna");
};
